import './vendor';
import './helpers';
import './components/social';
import Swiper, { Navigation, Pagination } from 'swiper';
import { Fancybox } from "@fancyapps/ui";
import aos from 'aos';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';

Swiper.use([Navigation, Pagination]);

const $document = $(document);
const $window = $(window);
const $html = $('html');
const $body = $('body');

aos.init({
	duration: 800,
	easing: 'ease-in-out',
	offset: 300,
	once: true,
});

let app = {
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let $target = $($(e.currentTarget).data('target') || $(e.currentTarget).attr('href'));

				if ($target.length) {
					e.preventDefault();
					window.scrollTo(0, $target.offset().top - 140);
				}
				$html.removeClass('is-show-menu');
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});

			// new WOW().init();

			// $('[data-fancybox]').fancybox({
			// 	touch: false,
			// 	autoFocus: false,
			// 	backFocus: false,
			// });

			$('head').append(`<style type="text/css">
				html {
					--compensate-scrollbar:${(window.innerWidth - document.documentElement.clientWidth) / -2}px;
				}
				</style>`);

			$body.css({
				'--width': $window.outerWidth(),
			});
			$window.on('resize', () => {
				$body.css({
					'--width': $window.outerWidth(),
				});
			});
		},
	},
	vw(px) {
		const base = 1440;

		const baseMobile = 375;

		let output = px;

		if ($window.outerWidth() < 1300) {
			output = px / base * $window.outerWidth();
		}

		if ($window.outerWidth() < 1025) {
			output = px / baseMobile * $window.outerWidth();
		}

		return output;
	},
	numberWithSpaces(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	},
	numberWithoutSpaces(x) {
		return parseInt(x.toString().replace(/ /g, ''), 10);
	},
	header: {
		init($module) {
			$window.on('scroll.header', () => {
				if ($window.scrollTop() > 15) {
					$module.addClass('is-fixed');
				} else {
					$module.removeClass('is-fixed');
				}
			}).trigger('scroll.header');
		},
	},
	mask: {
		init($mask) {
			$mask.inputmask($mask.data('mask').toString(), {
				showMaskOnHover: false,
				clearIncomplete: true,
			});
		},
	},
	about: {
		init($module) {
			new Swiper($module.find('.about__certificates__slider .swiper')[0], {
				slidesPerView: 'auto',
				spaceBetween: app.vw(30),
				navigation: {
					prevEl: $module.find('.about__certificates__slider__prev')[0],
					nextEl: $module.find('.about__certificates__slider__next')[0],
				},
				breakpoints: {
					1024: {
						slidesPerView: 4,
						spaceBetween: app.vw(32),
					},
				},
			});
		},
	},
	services: {
		init($module) {
			$module.find('.services__accordion__item__head').on('click', (e) => {
				const $this = $(e.currentTarget);
				const $item = $this.closest('.services__accordion__item');
				const $content = $item.find('.services__accordion__item__content');

				e.preventDefault();
				if (!$item.hasClass('services__accordion__item--disabled')) {
					if ($item.hasClass('is-active')) {
						$item.removeClass('is-active');
						$content.stop().slideUp(400);
					} else {
						$item.addClass('is-active');
						$content.stop().slideDown(400);
					}
				}
			});
		},
	},
	reviews: {
		init($module) {
			new Swiper($module.find('.reviews__slider .swiper')[0], {
				slidesPerView: 'auto',
				spaceBetween: app.vw(30),
				loop: true,
				navigation: {
					prevEl: $module.find('.reviews__slider__prev')[0],
					nextEl: $module.find('.reviews__slider__next')[0],
				},
				breakpoints: {
					1024: {
						slidesPerView: 3,
						spaceBetween: app.vw(40),
					},
				},
			});
		},
	},
	scriptLoading(src, callback) {
		let script = document.createElement('script');
		let loaded;

		script.setAttribute('src', src);
		if (callback) {
			script.onreadystatechange = script.onload = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	},
};

app.global.init();

window.initApps = () => {
	$('[data-app]').each((index, item) => {
		let $this = $(item);
		let split = $this.data('app').split('||');

		$.each(split, (appIndex, appName) => {
			let appNameCamel = false;

			if (appName.indexOf('-') !== -1) {
				appNameCamel = appName.replace(/(-|\s)(\S)/ug, (m) => m.toUpperCase()).replace(/-/ug, '');
			}

			if (app[appName] && $this.data(`${appName}-init`) !== true) {
				app[appName].init($this);
				$this.data(`${appName}-init`, true);
			} else if (app[appNameCamel] && $this.data(`${appName}-init`) !== true) {
				app[appNameCamel].init($this);
				$this.data(`${appName}-init`, true);
			}
		});
	});
};

initApps();

$window.on('scroll.line', () => {
	let dashOffset = 4670;
	let dashOffsetStart = 2705;

	if ($('.section-blue__line:visible').hasClass('for-mobile')) {
		dashOffset = 2351;
		dashOffsetStart = 1133;
	}

	let cur = $window.scrollTop() + $window.outerHeight() * (2 / 3);
	let end = $('.section-blue').outerHeight();
	let value = dashOffset - cur / end * dashOffset;

	if (value > dashOffsetStart) {
		value = dashOffsetStart;
	} else if (value < 0) {
		value = 0;
	}

	if (value >= dashOffsetStart) {
		$('.section-blue__line').addClass('is-start');
	} else {
		$('.section-blue__line').removeClass('is-start');
	}

	$('.section-blue__line:visible').css({
		strokeDashoffset: value,
	});
}).trigger('scroll.line');
